module.exports = __webpack_public_path__ + "images/[1]Premium_Exterieurs_12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[1]Premium_Exterieurs_12.jpg
// module id = 33
// module chunks = 0